import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBusinessAuth } from '../../contexts/BusinessAuthContext';
import './DaycareNavBar.css';

const DaycareNavBar = () => {
  const { daycare, logout, isAuthenticated } = useBusinessAuth();
  const location = useLocation();

  if (!isAuthenticated()) {
    return null;
  }

  const isActive = (path) => location.pathname === path;

  return (
    <div className="daycare-navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <h1>🐕 BarkBacks</h1>
          <span className="brand-tagline">Video Generation Platform</span>
        </div>

        <nav className="navbar-nav">
          <Link
            to="/videos"
            className={`nav-link ${isActive('/videos') ? 'active' : ''}`}
          >
            Videos
          </Link>
          <Link
            to="/analytics"
            className={`nav-link ${isActive('/analytics') ? 'active' : ''}`}
          >
            Analytics
          </Link>
          <Link
            to="/customers"
            className={`nav-link ${isActive('/customers') || location.pathname.startsWith('/customers/') ? 'active' : ''}`}
          >
            Customers
          </Link>
        </nav>

        <div className="navbar-info">
          <div className="daycare-info">
            <div className="daycare-name">
              <strong>{daycare.daycareName}</strong>
            </div>
            <div className="subscription-badge">
              {daycare.subscription.plan === 'free' ? '🆓' : '⭐'} {daycare.subscription.plan.toUpperCase()}
            </div>
            <div className="video-quota">
              {daycare.subscription.videosUsedThisMonth} / {daycare.subscription.videosPerMonth} videos used
            </div>
          </div>

          <button onClick={logout} className="logout-button">
            🚪 Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default DaycareNavBar;
